export function startDownload(fileContent: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(fileContent);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}
